import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { endsWithSegment } from "router5-helpers";

import ConfirmEmailPage from "modules/auth/confirm-email-page";
import CreatePasswordPage from "modules/auth/create-password-page";
import CreateAccountPage from "modules/auth/create-account-page";
import SignUpFinished from "modules/auth/sign-up-finished";
import * as RoutingSelectors from "modules/routing/routing-selectors";
import {
  SIGN_UP,
  SIGN_UP_FINISHED,
  CONFIRM_EMAIL,
  CREATE_PASSWORD
} from "modules/routing/routes";

class SignUpPage extends Component {
  static propTypes = {
    routeName: PropTypes.string,
    routeParams: PropTypes.object
  };

  state = {
    email: ""
  };

  onChangeEmail = (_, email) => {
    this.setState({ email });
  };

  render() {
    const { routeName, routeParams } = this.props;
    const email = routeParams.email || this.state.email;

    const endsWith = endsWithSegment(routeName);
    return (
      <Fragment>
        {!endsWith(SIGN_UP_FINISHED) && (
          <div className="l-container">
            {endsWith(SIGN_UP) && (
              <CreateAccountPage
                email={email}
                onChangeEmail={this.onChangeEmail}
              />
            )}
            {endsWith(CONFIRM_EMAIL) && (
              <ConfirmEmailPage
                email={email}
                onChangeEmail={this.onChangeEmail}
              />
            )}
            {endsWith(CREATE_PASSWORD) && <CreatePasswordPage email={email} />}
          </div>
        )}
        {endsWith(SIGN_UP_FINISHED) && <SignUpFinished />}
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  routeName: RoutingSelectors.getCurrentRouteName(state),
  routeParams: RoutingSelectors.getCurrentRouteParams(state)
});

export default connect(mapStateToProps)(SignUpPage);



// WEBPACK FOOTER //
// ./src/modules/auth/sign-up-page.js